// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-tournament {
    /* background-color: var( --white-color ); */
    padding: var( --space ) var( --space-x2 ) var( --space-eighth ) var( --space-x2 );
    border-radius: calc( var( --space ) - var( --space-eighth ) );
    /* box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25); */
}
.new-tournament__container{
    position: relative;
}

.edit-tournament__center__content {
    background: var(--white-color);
}

.tournament-edit-tournament__label {
    display: flex;
    align-items: center;
    margin: var( --space-and-half ) 0;
    padding-left: var(--space-x2);
}

.tournament-edit-tournament__label  .icon-arrow-left {
    font-size: var(--space-and-half);
    cursor: pointer;
    margin-right: calc( var( --space-and-half ) + var( --space-quarter ) );
}

.new-tournament__center__header__content__icon .icon-arrow-left {
    color: var(--primary-dark-color);
}

.tournament-edit-tournament__label  .baloa-headline-2 {
    color: var( --primary-very-dark-color );
}

.new-tournament__center__header__button .button.secondary-button {
    border: 2px solid var(--error-color);
    color: var( --error-color );
    white-space: nowrap;
}

.new-tournament__center__header__button .button.secondary-button:disabled {
    border: 2px solid var(--primary-light-color);
    color: var(--primary-light-color);
}

.new-tournament__center__content__tabs {
    /* margin-top: var( --space-half ); */
}

.new-tournament__center__content__tabs .MuiTabs-flexContainer {
    border-top: 1px solid var( --new-gray-background-color );
    border-bottom: 1px solid var( --new-gray-background-color );
}

.new-tournament__center__content__tabs .MuiTab-fullWidth {
    flex-basis: initial;
}

.tabpanel-line {
    /* border: 1px solid var(--primary-light-color); */
    margin: var(--space-and-half) 0 var(--space-x2) 0;
    padding: 0 var(--space-x2) var(--space-x2) var(--space-x2);
}

.tabpanel-line.podium {
    margin: 0;
    padding: var(--space-x2) 0 var(--space-x2) 0;
    background: var(--new-background-color);
}

.tabs-icons_style_container {
    width: auto;
    padding: 0;
    flex-direction: row-reverse !important;
}
.new-tournament__center__content__tabs .MuiTabs-flexContainer .MuiButtonBase-root {
    min-width: 100px;
}

.new-tournament__center__content__tabs .MuiTab-wrapper {
    font-family: var( --secondary-font );
    font-style: normal;
    font-weight: var( --font-medium );
    font-size: calc(var(--space) + 1px); /*17px*/
    line-height: calc(var(--space) + var(--space-quarter));/* 20px */
    letter-spacing: 0.005em;
    color: var( --basic-gray-color );
    text-transform: none;
}

.new-tournament__center__header__content__title__text .baloa-headline-2 {
    color: var( --primary-very-dark-color );
    text-transform: capitalize;
    margin-bottom: var( --space-quarter );
}

.new-tournament__center__header__content__title__text .baloa-normal-text {
    color: var( --primary-dark-color );
    text-transform: capitalize;
    margin-bottom: var( --space-quarter );
}

.new-tournament__center__content__tabs .MuiTab-root.Mui-selected * {
    color: var( --primary-dark-color ) !important;
}

.tournament-edit-tournament__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--space-and-half);
    padding-left: 12px;
    background-color: var(--white-color);
}

.tournament-edit-tournament__classified {
    display: flex;
    align-items: center;
    margin-left: var(--space-x2);           
}

.tournament-edit-tournament__classified:first-of-type {
    margin-top: var(--space-x2);
    margin-bottom: var(--space);      
}

.tournament-edit-tournament__classified-square {
    width: 16px;
    height: 16px;
    border-radius: 2px;
    background-color: var(--new-green-color);
    margin-right: var(--space-half-quarter);
}

.tournament-edit-tournament__best-third-square {
    width: 16px;
    height: 16px;
    border-radius: 2px;
    background-color: #FA7B17;
    margin-right: var(--space-half-quarter);
}

.new-tournament__center-container{
    /* position: absolute; */
    width: 100%;
    height: 229px;
    overflow: hidden;
    display: flex;
    align-items: center;
    /* justify-content: center; */
    border-radius: 16px 16px 0px 0px;
}

.new-tournament__center-container-img{
    width: 100%;
}

.tournament-edit-tournament__header .left-col{
    display: flex;
    align-items: center;
    width: 100%;
}

.tournament-edit-tournament__header .left-col img{
    width: 45px;
    height: 45px;
    border-radius: 50%;
    margin-right: var( --space );
}

.tournament-edit-tournament__header .right-col{
    width: 25%
}


.new-tournament-img_container {
    position: absolute;
    width: 100%;
    height: 229px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 16px 16px 0px 0px;
}

.new-tournament__image{
    border-radius: 16px 16px 0px 0px;
    background: rgba(77, 84, 81, 0.64);
    backdrop-filter: blur(4px);  
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.new-tournament__image .icon-trophy{
    color: var(--white-color);
    font-size: 52px;
    width: 419px;
    height: 229px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.new-tournament__image img{
    width: 419px;
    height: 229px;
}

.tournament-edit-tournament__header-labels {
    position: absolute;
    display: flex;
    bottom: 0;
    justify-content: flex-start;
    align-items: flex-start;
}

.tournament-edit-tournament__tournament-info {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    justify-content: space-between;
    width: 100%;
    padding: 8px 16px;
}

.tournament-edit-tournament__tournament-info__labels {
    display: flex;
    align-items: center;
    gap: var(--space-half);
    
}
.tournament-edit-tournament__tournament-info__share-btn.small {
    display: flex;
    align-items: center;
    padding: var(--space-half-quarter);
}

.tournament-edit-tournament__tournament-info__share-btn.small:hover .baloa-table {
    color: var(--white-color);
}

.tournament-edit-tournament__tournament-info__share-btn .hubicon-share_v2 {
    margin-right: var(--space-half-quarter);
}

.tournament-edit-tournament__tournament-info__share-btn .baloa-table {
    font-weight: var(--font-medium);
    color: var(--primary-dark-color);
}

.tournament-edit-tournament__tournament-info__share-btn.small:focus .baloa-table {
    color: var(--white-color);
}

.tournament-edit-tournament__heder-label {
    background: rgba(0, 0, 0, 0.61);
    color: var( --white-color );
    border-radius: var( --space-and-half );
    padding: var(--space-quarter) var(--space-half);
}

/* .tournament-edit-tournament__heder-label:nth-of-type(2) {
    margin: 0 var(--space-half);
} */

.tournament-edit-tab-calendar-add-teams_Phase{
    display: flex;
    align-content: center;
    align-items: center;
    background: var(--new-informative-banner-bg-color);
    border-radius: var(--space-half);   
    justify-content: space-between;
    padding: var(--space-half-quarter);
    margin-top: var(--space-and-half);
    border-left: var(--space-half) solid var(--new-informative-banner-color);
}

.tournament-edit-tab-calendar-add-team_text{
    display: flex;
    gap: var(--space);
    align-items: center;
}

.tournament-edit-tab-calendar-add-team_text .hubicon-info {
    font-size: var(--space);
}

.tournament-edit-tab-calendar-add-team_text .hubicon-info::before {
    color: var(--new-informative-banner-color);
}

.tournament-edit-tab-calendar-add-teams_phase_button{
    text-transform: initial;
    padding: calc( var(--space-half) + var(--space-eighth) ) calc( var(--space) + var(--space-quarter) );
    font-size: calc(var(--space) + 1px);
    line-height: calc(var(--space) + var(--space-quarter));
    display: flex;
    align-items: center;
    gap: var(--space-half-quarter);
}

.tournament-edit-tab-calendar-add-teams_phase_button .hubicon-low_priority{
    font-size: calc(var(--space) + var(--space-quarter));
}

.tournament-edit-tab-calendar-add-teams_phase_button .hubicon-low_priority::before{
    color: var(--white-color);
}

.tournament-edit-tournament_iframe_options{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex-direction: row;
    overflow-x: scroll;
}

.tournament-edit-tournament__no-phases__container {
    display: flex;
    align-content: center;
    align-items: center;
    background: var(--new-informative-banner-bg-color);
    border-radius: var(--space-half);   
    justify-content: space-between;
    padding: var(--space-half-quarter);
    margin-top: var(--space-and-half);
    border-left: var(--space-half) solid var(--new-informative-banner-color);
}

.tournament-edit-tournament__no-phases {
    display: flex;
    align-items: center;
    gap: var(--space);
}

.tournament-edit-tournament__no-phases .hubicon-info {
    font-size: var(--space);
}

.tournament-edit-tournament__no-phases .hubicon-info::before {
    color: var(--new-informative-banner-color);
}

.tournament-edit-tournament__no-phases__container .primary-button {
    padding: calc( var(--space-half) + var(--space-eighth) ) calc( var(--space) + var(--space-quarter) );
    font-size: calc(var(--space) + 1px);
    line-height: calc(var(--space) + var(--space-quarter));
}

.tournament-edit-tournament__player-resume-stats {
    margin: 0 24px;
    padding: 12px  20px;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.tournament-edit-tournament__player-resume-stats__title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
}

.tournament-edit-tournament__player-resume-stats__title .baloa-names {
    color: var(--basic-gray-color);
}

.tournament-edit-tournament__player-resume-stats__stats {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 70px;
    margin-top: 12px;
}

.tournament-edit-tournament__player-resume-stats__stats-col .baloa-table {
    color: var(--basic-gray-color);
    margin-bottom: 4px;
}

.tournament-edit-tournament__player-resume-stats__stats-col .baloa-names {
    color: var(--primary-very-dark-color);    
}

.tournament-edit-tournament__player-resume-stats__title__tooltip .hubicon-help_fill {
    font-size: 20px;    
}

.tournament-edit-tournament__player-resume-stats__title__tooltip .hubicon-help_fill::before {
    color: var(--new-green-color);
    opacity: 0.7;
    cursor: pointer;
}

.tournament-edit-tournament__player-resume-stats__title__tooltip {
    position: relative;
}

.tournament-edit-tournament__player-resume-stats__title__tooltip .baloa-table-column {
    font-weight: var(--font-regular);
    color: var(--primary-dark-color);
    padding: 13px 10px;
    position: absolute;
    width: 300px;
    height: 116px;
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 5px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));
    bottom: 42px;
    left: -138px;
    display: none;
}

.tournament-edit-tournament__player-resume-stats__title__tooltip:hover .baloa-table-column {
    display: block;
}

.tournament-edit-tournament__player-resume-stats__title__tooltip .baloa-table-column:after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 50%;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid var(--white-color);
    transform: translateX(-50%);
}

.tabpanel-line.stats {
    margin: unset;
    padding: unset;
    background: var(--new-background-color);
}

.tournament-edit-tournament_stats,
.tournament-edit-tournament_stats .tournament-statistics__amonished {
    padding-top: 12px;
    padding-bottom: 12px;
}

.tournament-edit-tournament_stats .tournament-statistics__amonished-title{
    display: none;
}


@media screen and ( max-width: 1300px ) {

    .new-tournament {
        padding: var( --space ) var( --space-half ) var( --space-eighth ) var( --space-half );
    }
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-edit-tournament/TournamentEditTournamentComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,4CAA4C;IAC5C,iFAAiF;IACjF,6DAA6D;IAC7D,uDAAuD;AAC3D;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iCAAiC;IACjC,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,sEAAsE;AAC1E;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,4CAA4C;IAC5C,iCAAiC;AACrC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,wDAAwD;IACxD,2DAA2D;AAC/D;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kDAAkD;IAClD,iDAAiD;IACjD,0DAA0D;AAC9D;;AAEA;IACI,SAAS;IACT,4CAA4C;IAC5C,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,UAAU;IACV,sCAAsC;AAC1C;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,iCAAiC;IACjC,mCAAmC,EAAE,OAAO;IAC5C,sDAAsD,CAAC,SAAS;IAChE,uBAAuB;IACvB,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,uCAAuC;IACvC,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,kCAAkC;IAClC,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,8BAA8B;IAC9B,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI;AACJ;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,8BAA8B;IAC9B,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;;AAE1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;IAC/B,2BAA2B;IAC3B,sCAAsC;IACtC,+CAA+C;AACnD;;AAEA;;GAEG;;AAEH;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,kDAAkD;IAClD,gCAAgC;IAChC,8BAA8B;IAC9B,kCAAkC;IAClC,iCAAiC;IACjC,wEAAwE;AAC5E;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,uBAAuB;IACvB,oGAAoG;IACpG,mCAAmC;IACnC,sDAAsD;IACtD,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,kDAAkD;IAClD,gCAAgC;IAChC,8BAA8B;IAC9B,kCAAkC;IAClC,iCAAiC;IACjC,wEAAwE;AAC5E;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,oGAAoG;IACpG,mCAAmC;IACnC,sDAAsD;AAC1D;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;AACZ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,kDAAkD;IAClD,kBAAkB;IAClB,oDAAoD;IACpD,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,mCAAmC;IACnC,oCAAoC;IACpC,yCAAyC;IACzC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,uCAAuC;AAC3C;;AAEA;;IAEI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;;AAGA;;IAEI;QACI,qFAAqF;IACzF;AACJ","sourcesContent":[".new-tournament {\n    /* background-color: var( --white-color ); */\n    padding: var( --space ) var( --space-x2 ) var( --space-eighth ) var( --space-x2 );\n    border-radius: calc( var( --space ) - var( --space-eighth ) );\n    /* box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25); */\n}\n.new-tournament__container{\n    position: relative;\n}\n\n.edit-tournament__center__content {\n    background: var(--white-color);\n}\n\n.tournament-edit-tournament__label {\n    display: flex;\n    align-items: center;\n    margin: var( --space-and-half ) 0;\n    padding-left: var(--space-x2);\n}\n\n.tournament-edit-tournament__label  .icon-arrow-left {\n    font-size: var(--space-and-half);\n    cursor: pointer;\n    margin-right: calc( var( --space-and-half ) + var( --space-quarter ) );\n}\n\n.new-tournament__center__header__content__icon .icon-arrow-left {\n    color: var(--primary-dark-color);\n}\n\n.tournament-edit-tournament__label  .baloa-headline-2 {\n    color: var( --primary-very-dark-color );\n}\n\n.new-tournament__center__header__button .button.secondary-button {\n    border: 2px solid var(--error-color);\n    color: var( --error-color );\n    white-space: nowrap;\n}\n\n.new-tournament__center__header__button .button.secondary-button:disabled {\n    border: 2px solid var(--primary-light-color);\n    color: var(--primary-light-color);\n}\n\n.new-tournament__center__content__tabs {\n    /* margin-top: var( --space-half ); */\n}\n\n.new-tournament__center__content__tabs .MuiTabs-flexContainer {\n    border-top: 1px solid var( --new-gray-background-color );\n    border-bottom: 1px solid var( --new-gray-background-color );\n}\n\n.new-tournament__center__content__tabs .MuiTab-fullWidth {\n    flex-basis: initial;\n}\n\n.tabpanel-line {\n    /* border: 1px solid var(--primary-light-color); */\n    margin: var(--space-and-half) 0 var(--space-x2) 0;\n    padding: 0 var(--space-x2) var(--space-x2) var(--space-x2);\n}\n\n.tabpanel-line.podium {\n    margin: 0;\n    padding: var(--space-x2) 0 var(--space-x2) 0;\n    background: var(--new-background-color);\n}\n\n.tabs-icons_style_container {\n    width: auto;\n    padding: 0;\n    flex-direction: row-reverse !important;\n}\n.new-tournament__center__content__tabs .MuiTabs-flexContainer .MuiButtonBase-root {\n    min-width: 100px;\n}\n\n.new-tournament__center__content__tabs .MuiTab-wrapper {\n    font-family: var( --secondary-font );\n    font-style: normal;\n    font-weight: var( --font-medium );\n    font-size: calc(var(--space) + 1px); /*17px*/\n    line-height: calc(var(--space) + var(--space-quarter));/* 20px */\n    letter-spacing: 0.005em;\n    color: var( --basic-gray-color );\n    text-transform: none;\n}\n\n.new-tournament__center__header__content__title__text .baloa-headline-2 {\n    color: var( --primary-very-dark-color );\n    text-transform: capitalize;\n    margin-bottom: var( --space-quarter );\n}\n\n.new-tournament__center__header__content__title__text .baloa-normal-text {\n    color: var( --primary-dark-color );\n    text-transform: capitalize;\n    margin-bottom: var( --space-quarter );\n}\n\n.new-tournament__center__content__tabs .MuiTab-root.Mui-selected * {\n    color: var( --primary-dark-color ) !important;\n}\n\n.tournament-edit-tournament__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: var(--space-and-half);\n    padding-left: 12px;\n    background-color: var(--white-color);\n}\n\n.tournament-edit-tournament__classified {\n    display: flex;\n    align-items: center;\n    margin-left: var(--space-x2);           \n}\n\n.tournament-edit-tournament__classified:first-of-type {\n    margin-top: var(--space-x2);\n    margin-bottom: var(--space);      \n}\n\n.tournament-edit-tournament__classified-square {\n    width: 16px;\n    height: 16px;\n    border-radius: 2px;\n    background-color: var(--new-green-color);\n    margin-right: var(--space-half-quarter);\n}\n\n.tournament-edit-tournament__best-third-square {\n    width: 16px;\n    height: 16px;\n    border-radius: 2px;\n    background-color: #FA7B17;\n    margin-right: var(--space-half-quarter);\n}\n\n.new-tournament__center-container{\n    /* position: absolute; */\n    width: 100%;\n    height: 229px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    /* justify-content: center; */\n    border-radius: 16px 16px 0px 0px;\n}\n\n.new-tournament__center-container-img{\n    width: 100%;\n}\n\n.tournament-edit-tournament__header .left-col{\n    display: flex;\n    align-items: center;\n    width: 100%;\n}\n\n.tournament-edit-tournament__header .left-col img{\n    width: 45px;\n    height: 45px;\n    border-radius: 50%;\n    margin-right: var( --space );\n}\n\n.tournament-edit-tournament__header .right-col{\n    width: 25%\n}\n\n\n.new-tournament-img_container {\n    position: absolute;\n    width: 100%;\n    height: 229px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 16px 16px 0px 0px;\n}\n\n.new-tournament__image{\n    border-radius: 16px 16px 0px 0px;\n    background: rgba(77, 84, 81, 0.64);\n    backdrop-filter: blur(4px);  \n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n\n.new-tournament__image .icon-trophy{\n    color: var(--white-color);\n    font-size: 52px;\n    width: 419px;\n    height: 229px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.new-tournament__image img{\n    width: 419px;\n    height: 229px;\n}\n\n.tournament-edit-tournament__header-labels {\n    position: absolute;\n    display: flex;\n    bottom: 0;\n    justify-content: flex-start;\n    align-items: flex-start;\n}\n\n.tournament-edit-tournament__tournament-info {\n    display: flex;\n    align-items: center;\n    position: absolute;\n    bottom: 0;\n    justify-content: space-between;\n    width: 100%;\n    padding: 8px 16px;\n}\n\n.tournament-edit-tournament__tournament-info__labels {\n    display: flex;\n    align-items: center;\n    gap: var(--space-half);\n    \n}\n.tournament-edit-tournament__tournament-info__share-btn.small {\n    display: flex;\n    align-items: center;\n    padding: var(--space-half-quarter);\n}\n\n.tournament-edit-tournament__tournament-info__share-btn.small:hover .baloa-table {\n    color: var(--white-color);\n}\n\n.tournament-edit-tournament__tournament-info__share-btn .hubicon-share_v2 {\n    margin-right: var(--space-half-quarter);\n}\n\n.tournament-edit-tournament__tournament-info__share-btn .baloa-table {\n    font-weight: var(--font-medium);\n    color: var(--primary-dark-color);\n}\n\n.tournament-edit-tournament__tournament-info__share-btn.small:focus .baloa-table {\n    color: var(--white-color);\n}\n\n.tournament-edit-tournament__heder-label {\n    background: rgba(0, 0, 0, 0.61);\n    color: var( --white-color );\n    border-radius: var( --space-and-half );\n    padding: var(--space-quarter) var(--space-half);\n}\n\n/* .tournament-edit-tournament__heder-label:nth-of-type(2) {\n    margin: 0 var(--space-half);\n} */\n\n.tournament-edit-tab-calendar-add-teams_Phase{\n    display: flex;\n    align-content: center;\n    align-items: center;\n    background: var(--new-informative-banner-bg-color);\n    border-radius: var(--space-half);   \n    justify-content: space-between;\n    padding: var(--space-half-quarter);\n    margin-top: var(--space-and-half);\n    border-left: var(--space-half) solid var(--new-informative-banner-color);\n}\n\n.tournament-edit-tab-calendar-add-team_text{\n    display: flex;\n    gap: var(--space);\n    align-items: center;\n}\n\n.tournament-edit-tab-calendar-add-team_text .hubicon-info {\n    font-size: var(--space);\n}\n\n.tournament-edit-tab-calendar-add-team_text .hubicon-info::before {\n    color: var(--new-informative-banner-color);\n}\n\n.tournament-edit-tab-calendar-add-teams_phase_button{\n    text-transform: initial;\n    padding: calc( var(--space-half) + var(--space-eighth) ) calc( var(--space) + var(--space-quarter) );\n    font-size: calc(var(--space) + 1px);\n    line-height: calc(var(--space) + var(--space-quarter));\n    display: flex;\n    align-items: center;\n    gap: var(--space-half-quarter);\n}\n\n.tournament-edit-tab-calendar-add-teams_phase_button .hubicon-low_priority{\n    font-size: calc(var(--space) + var(--space-quarter));\n}\n\n.tournament-edit-tab-calendar-add-teams_phase_button .hubicon-low_priority::before{\n    color: var(--white-color);\n}\n\n.tournament-edit-tournament_iframe_options{\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    flex-direction: row;\n    overflow-x: scroll;\n}\n\n.tournament-edit-tournament__no-phases__container {\n    display: flex;\n    align-content: center;\n    align-items: center;\n    background: var(--new-informative-banner-bg-color);\n    border-radius: var(--space-half);   \n    justify-content: space-between;\n    padding: var(--space-half-quarter);\n    margin-top: var(--space-and-half);\n    border-left: var(--space-half) solid var(--new-informative-banner-color);\n}\n\n.tournament-edit-tournament__no-phases {\n    display: flex;\n    align-items: center;\n    gap: var(--space);\n}\n\n.tournament-edit-tournament__no-phases .hubicon-info {\n    font-size: var(--space);\n}\n\n.tournament-edit-tournament__no-phases .hubicon-info::before {\n    color: var(--new-informative-banner-color);\n}\n\n.tournament-edit-tournament__no-phases__container .primary-button {\n    padding: calc( var(--space-half) + var(--space-eighth) ) calc( var(--space) + var(--space-quarter) );\n    font-size: calc(var(--space) + 1px);\n    line-height: calc(var(--space) + var(--space-quarter));\n}\n\n.tournament-edit-tournament__player-resume-stats {\n    margin: 0 24px;\n    padding: 12px  20px;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.tournament-edit-tournament__player-resume-stats__title {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 8px;\n}\n\n.tournament-edit-tournament__player-resume-stats__title .baloa-names {\n    color: var(--basic-gray-color);\n}\n\n.tournament-edit-tournament__player-resume-stats__stats {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 70px;\n    margin-top: 12px;\n}\n\n.tournament-edit-tournament__player-resume-stats__stats-col .baloa-table {\n    color: var(--basic-gray-color);\n    margin-bottom: 4px;\n}\n\n.tournament-edit-tournament__player-resume-stats__stats-col .baloa-names {\n    color: var(--primary-very-dark-color);    \n}\n\n.tournament-edit-tournament__player-resume-stats__title__tooltip .hubicon-help_fill {\n    font-size: 20px;    \n}\n\n.tournament-edit-tournament__player-resume-stats__title__tooltip .hubicon-help_fill::before {\n    color: var(--new-green-color);\n    opacity: 0.7;\n    cursor: pointer;\n}\n\n.tournament-edit-tournament__player-resume-stats__title__tooltip {\n    position: relative;\n}\n\n.tournament-edit-tournament__player-resume-stats__title__tooltip .baloa-table-column {\n    font-weight: var(--font-regular);\n    color: var(--primary-dark-color);\n    padding: 13px 10px;\n    position: absolute;\n    width: 300px;\n    height: 116px;\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 5px;\n    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));\n    bottom: 42px;\n    left: -138px;\n    display: none;\n}\n\n.tournament-edit-tournament__player-resume-stats__title__tooltip:hover .baloa-table-column {\n    display: block;\n}\n\n.tournament-edit-tournament__player-resume-stats__title__tooltip .baloa-table-column:after {\n    content: \"\";\n    position: absolute;\n    bottom: -10px;\n    left: 50%;\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-top: 10px solid var(--white-color);\n    transform: translateX(-50%);\n}\n\n.tabpanel-line.stats {\n    margin: unset;\n    padding: unset;\n    background: var(--new-background-color);\n}\n\n.tournament-edit-tournament_stats,\n.tournament-edit-tournament_stats .tournament-statistics__amonished {\n    padding-top: 12px;\n    padding-bottom: 12px;\n}\n\n.tournament-edit-tournament_stats .tournament-statistics__amonished-title{\n    display: none;\n}\n\n\n@media screen and ( max-width: 1300px ) {\n\n    .new-tournament {\n        padding: var( --space ) var( --space-half ) var( --space-eighth ) var( --space-half );\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
